import General from './general';

export default General;
